import React, { useEffect, useState, FC } from "react";
import Fab from "@mui/material/Fab";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { useMediaQuery, useTheme } from "@mui/material";
import Box from "@mui/material/Box";

type Props = {
  targetElm: React.RefObject<HTMLDivElement>;
  scrollElm: React.RefObject<HTMLDivElement>;
  distance: number;
};

const ScrollButtonHorizontal: FC<Props> = ({
  targetElm,
  scrollElm,
  distance,
}) => {
  const theme = useTheme();
  const [showScroll, setShowScroll] = useState(false);
  const isIphone = useMediaQuery(theme.breakpoints.down("sm"));
  const checkScrollLeft = () => {
    if (scrollElm.current) {
      const scrollLeft = scrollElm.current.scrollLeft;
      if (!showScroll && scrollLeft > distance && !isIphone) {
        setShowScroll(true);
      } else if (showScroll && scrollLeft <= distance) {
        setShowScroll(false);
      }
    }
  };

  const scrollLeft = () => {
    if (scrollElm.current) {
      scrollElm.current.scrollTo({
        left: 0,
        behavior: "smooth",
      });
    }
    // if (targetElm.current) {
    //   targetElm.current.scrollIntoView({
    //     behavior: "smooth",
    //     block: "nearest",
    //     inline: "start",
    //   });
    // }
  };

  useEffect(() => {
    const element = scrollElm.current;
    if (element) {
      element.addEventListener("scroll", checkScrollLeft);
      return () => {
        element.removeEventListener("scroll", checkScrollLeft);
      };
    }
  }, [scrollElm, showScroll]);

  return (
    <>
      {showScroll && (
        <Box
          sx={{
            position: "fixed", // 親要素基準の位置指定に変更
            zIndex: 40,
            right: "40px",
            top: "50%", // 縦方向の中央
            transform: "translateY(-50%)", // 正確に中央に配置
            marginBottom: "0px",
            [theme.breakpoints.down("md")]: {},
            [theme.breakpoints.down("sm")]: {},
          }}
        >
          <Fab color={"primary"} size="small" onClick={scrollLeft}>
            <ArrowBackIosNewIcon sx={{ color: theme.palette.foreColor.dark }} />
          </Fab>
        </Box>
      )}
    </>
  );
};
export default ScrollButtonHorizontal;
